export default {"state":"open","xlh":"12","name":"12","position":"12","remark":"12","orgId":"df25b10b5c2b404b8d1619dc44307e34"}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/operate/grant/queryDeviceBindInfo.js